import SoundUtils from './SoundUtils';
import MobileAudioFix from './MobileAudioFix';
import SynthPresets from './SynthPresets';

import {hasAnyWebAudioSupport, AudioContext} from '.';

const initialGain = 0.001;

export default class Synth {
  static synthKeys = Object.keys(SynthPresets);

  constructor() {
    if (!hasAnyWebAudioSupport) {
      this.play = () => {
        return null;
      };

      // eslint-disable-next-line no-constructor-return
      return null;
    }

    this.context = new AudioContext();

    this.mobileAudio = new MobileAudioFix(this.context);
    this.mobileAudio.init();
  }

  play(sound) {
    if (!Synth.synthKeys.includes(sound)) {
      return Error(`The requested sound is not available: ${sound}`);
    }

    const config = SynthPresets[sound];
    this._buildTone(config);
    this._patchOscillatorMethods();

    this.oscillator.start();

    const duration = this.context.currentTime + config.duration;
    return this._stop(duration);
  }

  _buildTone(config) {
    this.oscillator = this.context.createOscillator();
    this.gainNode = this.context.createGain();

    this.oscillator.connect(this.gainNode);
    this.gainNode.connect(this.context.destination);

    this.oscillator.type = config.wave;
    this.oscillator.frequency.setValueAtTime(config.freq.start, this.context.currentTime);
    this.oscillator.frequency.exponentialRampToValueAtTime(
      config.freq.end,
      this.context.currentTime + config.duration / 2,
    );

    this.gainNode.gain.setValueAtTime(initialGain, this.context.currentTime);
    this.gainNode.gain.exponentialRampToValueAtTime(
      config.volume,
      this.context.currentTime + config.duration / 6,
    );
  }

  _patchOscillatorMethods() {
    this.oscillator.start = SoundUtils.methodPatch.start(this.oscillator);
    this.oscillator.stop = SoundUtils.methodPatch.stop(this.oscillator);
  }

  _stop(duration) {
    this.gainNode.gain.exponentialRampToValueAtTime(initialGain, duration);
    this.oscillator.stop(duration);
  }
}
